import React from "react";
import styles from "./contentCard.module.scss";

type ContentCardProps = {
  variant:
    | "main"
    | "chart"
    | "analysis-capacity"
    | "download-capacity"
    | "package-limit";
  children: React.ReactNode;
};

const ContentCard = ({
  variant,
  children,
}: ContentCardProps): React.JSX.Element => {
  return <div className={styles[variant]}>{children}</div>;
};

export default ContentCard;
